import React from "react";
import Accordion from "./Accordion.jsx";

const FAQ = ({ bgClassName }) => {
  return (
    <div id="FAQ" className={`${bgClassName || "bg-whiteprimary"} py-8 md:py-10 md:px-36 px-4`}>
      <Accordion />
    </div>
  );
};

export default FAQ;
